import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

import { checkUndefine } from '../../../../../../helpers/functions';
import DEFINE, { SUPPLIER, DATE_TIME_FORMAT, DETAIL_ACTIONS } from '../../../../../../constants/Define';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
    DatePickerComponent
} from "../../../../common/component/Index";
import Input from "../../../../common/component/Input";
import Radio from "../../../../common/component/Radio";
import Wrapper from "../../../../common/component/Wrapper";
import { Icon } from 'antd';
import { get, toArray } from 'lodash';
import './ContractInfo.less';
import Maps from '../../../../common/component/Maps';

export default class ContractInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { t, supplier, disabled, validation, uploading, typeCheckCode, action } = this.props;
        const disabledContractStatus = supplier.contractStatus === SUPPLIER.CONTRACT.STATUS.SIGNED.id
            && !!supplier.signedDate && !!supplier.contractNumber
            && !!supplier.id

        return (
            <Wrapper className="supplier-info-section">
                <FormWrapperItem>
                    <Wrapper className="col-md-12 row m-0 p-0 pl-3 pr-3">
                        <Wrapper className="col-md-12 m-0 p-0">
                            <FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={supplier.contactFullname}
                                validation={validation.contactFullname}
                                labelTitle={t(`item.supplier.contactFullname`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`contactFullname`} onChange={(e) => this.props.onChange('contactFullname', e.target.value)}
                                    value={checkUndefine(supplier.contactFullname)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className='col-md-12 m-0 p-0'>
                            <FormWrapperInputComponent
                                isRequired={ true }
                                isValidation={ true }
                                dataValidation={ supplier.code }
                                validation={ validation.code }
                                labelTitle={ t(`item.supplier.supplierCode`) }
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input type="text"
                                    className="form-control" name="code"
                                    value={ supplier.code }
                                    onChange={ e => this.props.onChange('code', e.target.value) }
                                />
                                { typeCheckCode && <span style={{color: 'red'}}>{t("item.supplier.invalidCode")}</span>}
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pr-md-2">
                            <FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={supplier.contactEmail}
                                validation={validation.contactEmail}
                                labelTitle={t(`item.supplier.contactEmail`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`contactEmail`} onChange={(e) => this.props.onChange('contactEmail', e.target.value)}
                                    value={checkUndefine(supplier.contactEmail)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pl-md-2">
                            <FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={supplier.contactPhoneNumber}
                                validation={validation.contactPhoneNumber}
                                labelTitle={t(`item.supplier.contactPhoneNumber`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`contactPhoneNumber`} onChange={(e) => this.props.onChange('contactPhoneNumber', e.target.value)}
                                    value={checkUndefine(supplier.contactPhoneNumber)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        
                        <Wrapper className="col-md-6 m-0 p-0 pr-md-2">
                            <FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={supplier.contractStatus}
                                validation={validation.contractStatus}
                                labelTitle={t(`item.supplier.contractStatus`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <br/>
                                <Radio.Group value={supplier.contractStatus}
                                    disabled={disabledContractStatus}
                                    onChange={e => this.props.onChange('contractStatus', e.target.value)}>
                                    {toArray(SUPPLIER.CONTRACT.STATUS).map(status => (
                                        <Radio key={status.key} value={status.id}>{t(`item.supplier.contract.status.${status.key}`)}</Radio>
                                    ))}
                                </Radio.Group>
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pl-md-2">
                            <FormWrapperInputComponent
                                isRequired={supplier.contractStatus !== SUPPLIER.CONTRACT.STATUS.UNSIGNED.id}
                                isValidation={true}
                                dataValidation={supplier.contractNumber}
                                validation={validation.contractNumber}
                                labelTitle={t(`item.supplier.contractNumber`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`contractNumber`} onChange={(e) => this.props.onChange('contractNumber', e.target.value)}
                                    value={checkUndefine(supplier.contractNumber)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pr-md-2">
                            <FormWrapperInputComponent
                                isRequired={supplier.contractStatus === SUPPLIER.CONTRACT.STATUS.SIGNED.id}
                                isValidation={true}
                                dataValidation={supplier.signedDate}
                                validation={validation.signedDate}
                                labelTitle={t(`item.supplier.signedDate`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <DatePickerComponent className={`form-control applyDates w100-percent`}
                                    disabledDate={this.disabledSignDate}
                                    hmsComponent={`DatePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                                    style={{ padding: 0, border: 0 }}
                                    onChange={this.onSelectDate} name={`signedDate`}
                                    placeholder={t('placeHolderForm.selectDate')}
                                    value={supplier.signedDate}
                                />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pl-md-2">
                            <FormWrapperInputComponent
                                isRequired={supplier.contractStatus === SUPPLIER.CONTRACT.STATUS.SIGNED.id}
                                isValidation={true}
                                dataValidation={supplier.contractEndDate}
                                validation={validation.contractEndDate}
                                labelTitle={t(`item.supplier.contractEndDate`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <DatePickerComponent className={`form-control applyDates w100-percent`}
                                    disabledDate={this.disabledEndDate}
                                    hmsComponent={`DatePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                                    style={{ padding: 0, border: 0 }}
                                    onChange={this.onSelectDate} name={`contractEndDate`}
                                    placeholder={t('placeHolderForm.selectDate')}
                                    value={supplier.contractEndDate}
                                />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pr-md-2">
                            <FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={this.props.napasReconEmail}
                                validation={validation.napasReconEmail}
                                labelTitle={t(`item.supplier.napasReconEmail`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="email1@example.com,email2@example.com" type={`text`}
                                    className={`form-control`}
                                    name={`napasReconEmail`}
                                    onChange={(e) => this.props.onChangeNapasReconEmail(e.target.value)}
                                    value={checkUndefine(this.props.napasReconEmail)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6 m-0 p-0 pl-md-2">
                            <FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={this.props.expiryMinutes}
                                validation={validation.expiryMinutes}
                                labelTitle={t(`item.supplier.expiryMinutes`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="" type={`number`} min={1}
                                    className={`form-control`}
                                    name={`expiryMinutes`}
                                    onChange={(e) => this.props.onChangeNapasExpiryMinutes(e.target.value)}
                                    value={checkUndefine(this.props.expiryMinutes)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-12 m-0 p-0">
                            <FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={supplier.website}
                                validation={validation.website}
                                labelTitle={t(`item.supplier.website`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`website`} onChange={(e) => this.props.onChange('website', e.target.value)}
                                    value={checkUndefine(supplier.website)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-12 m-0 p-0">
                            <FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={supplier.addressHyperLink}
                                validation={validation.addressHyperLink}
                                labelTitle={t(`item.supplier.linkMapGG`, 'Link nhúng gg map')}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`addressHyperLink`} onChange={(e) => this.props.onChange('addressHyperLink', e.target.value.trimLeft())}
                                    value={supplier?.addressHyperLink} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-12 location-on-map">
                            <FormWrapperInputComponent
                                labelTitle={t(`item.hotel.locationOnMap`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                {/* <Maps.GoogleMap
                                    center={get(supplier, 'position')}
                                    zoom={supplier.zoom}
                                    markers={get(supplier, 'position') ? [get(supplier, 'position')] : []}
                                    onMarkerDrag={this.onPositionChange} 
                                    onChangeZoom={this.onZoomChange}/> */}
                                <iframe src={supplier?.addressHyperLink} width="100%" height="450" 
                                    title="maps"
                                    style={{border: 0}}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade">
                                </iframe>
                            </FormWrapperInputComponent>
                        </Wrapper>
                    </Wrapper>
                </FormWrapperItem>
            </Wrapper>
        );
    }

    onSelectDate = (data) => {
        this.props.onChange(data.name, data.fullValue)
    } 

    onZoomChange = (data) => {
        this.props.onChange('zoom',data)
    }

    disabledSignDate = (current) => {
        const { supplier } = this.props;
        if(!supplier.contractEndDate){
            return false;
        }
        return current && current.startOf('days') >= supplier.contractEndDate.startOf('days');
    }

    disabledEndDate = (current) => {
        const { supplier } = this.props;
        if(!supplier.signedDate){
            return false;
        }
        return current && current.startOf('days') <= supplier.signedDate.startOf('days');
    }

    onPositionChange = (marker, event, index) => {
        if (event.position) {
            const position = {
                lat: event.position.lat(),
                lng: event.position.lng(),
            }
            this.props.onChange && this.props.onChange('position', position);
        }
    }

}

ContractInfo.defaultProps = {
    onChange: () => { },
    onChangeNapasReconEmail: () => { },
}
